import React from "react";
import ReactHtmlParser from "react-html-parser";
import replaceImageCdn from "@herb/utils/replaceImageCdn";
import HempBanSectionHead from "@herb/components/HempBan/HempBanSectionHead";
import "./index.css";

/**
 * "Three groups, three different clocks".
 *
 * `badgePosition` is truthy for the card whose tag overlays the top of the
 * image. The tag is always authored in the body and lifted over the media by
 * CSS, because the mobile frame keeps every tag in the body regardless.
 */
const HempBanImpacted = ({ whosImpacted }) => {
  if (!whosImpacted) {
    return null;
  }

  const { badgeText, heading, cards = [] } = whosImpacted;

  return (
    <section className="hb-section hb-impacted">
      <div className="hb-container">
        <HempBanSectionHead badgeText={badgeText} heading={heading} />

        {cards && cards.length ? (
          <div className="hb-impacted-grid">
            {cards.map((card, index) => {
              const desktopImage = card.image?.sourceUrl;
              const mobileImage = card.imageMobile?.sourceUrl || desktopImage;

              return (
                <article
                  className={`hb-impact-card${
                    card.badgePosition ? " hb-impact-card--tag-over" : ""
                  }`}
                  key={`${card.badgeText || "card"}-${index}`}
                >
                  {desktopImage ? (
                    <div className="hb-impact-media">
                      <picture>
                        <source
                          media="(max-width: 768px)"
                          srcSet={replaceImageCdn(mobileImage)}
                        />
                        <img
                          src={replaceImageCdn(desktopImage)}
                          alt={card.image?.altText || ""}
                          loading="lazy"
                        />
                      </picture>
                    </div>
                  ) : null}

                  <div className="hb-impact-body">
                    {card.badgeText ? (
                      <h3 className="hb-impact-tag">{card.badgeText}</h3>
                    ) : null}
                    {card.heading ? (
                      <div className="hb-impact-heading">{card.heading}</div>
                    ) : null}
                    {card.text ? (
                      <div className="hb-impact-text hb-rich">
                        {ReactHtmlParser(card.text)}
                      </div>
                    ) : null}
                  </div>
                </article>
              );
            })}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default HempBanImpacted;
